import { LogUserActivity } from '@/apis/users/requests'
import { useAppAlert } from '@/app/AppAlertProvider'
import {
  DOCUMENT_TYPES,
  DOCUMENT_VARIANTS,
} from '@/app/common/components/document-upload-new.constants'
import DocumentUploadSequence from '@/app/common/components/Documents/DocumentUploadSequence'
import useDocumentUpload from '@/app/common/components/useDocumentUploadNew'
import { FrameCornerIcon } from '@/app/common/icons/general'
import { parseRequestError } from '@/app/common/utilities'
import FamilyWizardLayout from '@/app/pages/family_application/FamilyWizardLayout.tsx'
import Drawer from '@/common/components/Drawer'
import { AppRoutePaths } from '@/routing/route_paths'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { LOG_TYPES } from '../../constants'

const IdentityDocumentCapture = () => {
  const { t: translate } = useTranslation()
  const navigateTo = useNavigate()
  const {fireAlert} = useAppAlert()

  const hasLoggedPageView = useRef(false);
  useEffect(() => {
    if (!hasLoggedPageView.current) {
      LogUserActivity({
        log_type: LOG_TYPES.VIEW_PAGE,
        suffix_text: 'the Submit Identity verification page',
      })
      hasLoggedPageView.current = true;
    }
  }, []) 

  const { mutate, status } = useDocumentUpload({
    variation: DOCUMENT_VARIANTS.IDENTITY_ID_CARD,
    type: DOCUMENT_TYPES.IDENTITY_ID,
    referer_page: 'manual_identity_verification',
    onSuccess: async (response) => {
      let validate_residency = true

      if (
        response?.ocr?.ocr_response?.errors != undefined &&
        response.ocr.ocr_response.errors.length > 0
      ) {
        fireAlert({
          variant: 'error',
          titleText: translate('identity'),
          messageComponent: (
            <>
              <p className="text-sm text-center mb-2">
                {translate('ocr_do_not_match')}
              </p>
              <p className=" text-center text-sm mt-1 text-gray-800">
                {translate('support_review_docs')}
              </p>
            </>
          ),
          denyBtn: true,
          denyBtnText: translate('retry'),
          confirmBtnText: translate('confirm'),
        }).then(({ confirmed, denied }) => {
          if (confirmed) {
            navigateTo(
              AppRoutePaths.family_application.identity_verification
                .success_manual_verification,
              {
                state: { validate_residency: validate_residency },
              }
            )

            return false
          }
          if (denied) {
            navigateTo(
              AppRoutePaths.family_application.identity_verification
                .document_capture
            )
            return false
          }
        })
      } else {
        if (
          response?.ocr?.residency_validated != undefined &&
          response.ocr.residency_validated
        ) {
          validate_residency = false
        }

        navigateTo(
          AppRoutePaths.family_application.identity_verification
            .success_manual_verification,
          {
            state: { validate_residency: validate_residency },
          }
        )
      }
    },
    onError: (error: unknown) => {
      const parsedError = parseRequestError(error)
      fireAlert({
        variant: 'error',
        message: parsedError.message,
      })
    },
    onSettled: () => {},
  })
  const [drawerOpen, setDrawerOpen] = useState(false)


  const logDontHaveDocuments = () => {
    LogUserActivity({
      log_type: LOG_TYPES.VIEW_PAGE,
      suffix_text: `the Other acceptable documents page`,
    })
  }

  return (
    <>
      <FamilyWizardLayout>
        <FamilyWizardLayout.Header>
          {translate('identity_verification')}
        </FamilyWizardLayout.Header>
        <FamilyWizardLayout.Content className="w-full">
          <DocumentUploadSequence
            onContinueClick={(image) => {
              mutate(image)
            }}
            status={status}
            uploadInformation={
              <div className="flex items-center">
                <div className="w-5 flex justify-center">
                  <FrameCornerIcon />
                </div>
                <div className="ml-4 text-sm">
                  {translate('position_your_document_identity_verification')}
                  <a
                    className="text-sm font-medium underline text-primary cursor-pointer"
                    onClick={() => {
                      logDontHaveDocuments()
                      setDrawerOpen(true)
                    }}
                  >
                    {' '}
                    {translate('i_dont_have_any_of_these_doc')}
                  </a>
                  {')'}
                </div>
              </div>
            }
          />
        </FamilyWizardLayout.Content>
      </FamilyWizardLayout>
      <Drawer open={drawerOpen} setOpen={setDrawerOpen} cssClass="z-40">
        <div className="text-xl font-medium text-gray-900 mb-3 sm:mb-2">
          {translate('other_acceptable_document')}
        </div>

        <div className="mt-4 mb-5">
          <ul className="ml-6 mt-2 text-gray-700 space-y-1 list-['-_']">
            <li>{translate('international_driver_license')}</li>
            <li>{translate('international_passport')}</li>
            <li>{translate('us_birth_certificate')}</li>
            <li>{translate('premanent_resident_card')}</li>
            <li>{translate('voter_registration_card')}</li>
            <li>{translate('certificate_of_naturalization')}</li>
          </ul>
        </div>
      </Drawer>
    </>
  )
}
export default IdentityDocumentCapture
